
<template>
  <div>
    <div class="wrapper">
      <div class="item">
        <div class="label">巡检任务</div>
        <div class="value">{{ detail.patrolCount }}个</div>
      </div>

      <div class="item">
        <div class="label">养护任务</div>
        <div class="value">{{ detail.maintenanceCount }}个</div>
      </div>
      <div class="item">
        <div class="label">维修任务</div>
        <div class="value">{{ detail.repairCount }}个</div>
      </div>
    </div>

    <div class="wrapper">
    </div>
    <div class="wrapper">
      <div class="chart" style="height: 13vh; flex: 1" id="task1"></div>
      <div class="chart" style="height: 13vh; flex: 1" id="task2"></div>
      <div class="chart" style="height: 13vh; flex: 1" id="task3"></div>
    </div>
  </div>
</template>

<script>
import request from "@/api/request";
import * as echarts from 'echarts/core';
import { TooltipComponent } from "echarts/components";
import { PieChart } from "echarts/charts";
import { LabelLayout } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([TooltipComponent, PieChart, CanvasRenderer, LabelLayout]);

export default {
  data() {
    return {
      detail: {},
      sewageChart: null,
    };
  },

  mounted() {
    request({
      url: "/model-analysis/inspectTask/queryFinishedTaskRate",
    }).then((res) => {
      console.log("task res", res);
      this.detail = res || {};
      this.initSewageChart();
      this.initRainChart();
      this.initChart();
    });
  },

  beforeDestroy() {
    this.sewageChart?.dispose();
    this.rainChart?.dispose();
    this.chart?.dispose();
  },

  methods: {
    initSewageChart() {
      var chartDom = document.getElementById("task1");
      this.sewageChart = echarts.init(chartDom);
      var option;

      option = {
        color: ["#FFA700", "#f0f0f0"],
        tooltip: {
          trigger: "item",
        },
        series: [
            {
                name: '巡检任务',
                type: 'pie',
                clockWise: false,
                radius: [40, 50],
                itemStyle: {
                    normal: {
                        label: {
                            show: false
                        },
                        labelLine: {
                            show: false
                        },
                        shadowBlur: 0,
                        shadowColor: '#203665'
                    }
                },
                hoverAnimation: false,
                center: ['50%', '50%'],
                data: [{
                    value: this.detail.patrolFinishedRate ? this.detail.patrolFinishedRate * 100 : 0,
                    label: {
                        normal: {
                            rich: {
                                a: {
                                    color: '#ffffff',
                                    align: 'center',
                                    fontSize: 16,
                                    fontWeight: "bold"
                                },
                                b: {
                                    color: '#66dbfc',
                                    align: 'center',
                                    fontSize: 14
                                }
                            },
                            formatter: function(params) {
                                return "{a|" + params.value + "%" + "}\n\n"+"{b|完成率}";
                            },
                            position: 'center',
                            show: true,
                            textStyle: {
                                fontSize: '12',
                                fontWeight: 'normal',
                                color: '#fff'
                            }
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: '#725bff',
                            shadowColor: '#613fd1',
                            shadowBlur: 0
                        }
                    }
                }, {
                    value: 75,
                    name: 'invisible',
                    itemStyle: {
                        normal: {
                            color: '#142331'
                        },

                    }
                }]
            },
        ],
      };


      option && this.sewageChart.setOption(option);
    },
    initRainChart() {
      var chartDom = document.getElementById("task2");
      this.rainChart = echarts.init(chartDom);
      var option;

        option = {
            color: ["#FFA700", "#f0f0f0"],
            tooltip: {
                trigger: "item",
            },
            series: [
                {
                    name: '巡检任务',
                    type: 'pie',
                    clockWise: false,
                    radius: [40, 50],
                    itemStyle: {
                        normal: {
                            label: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            },
                            shadowBlur: 0,
                            shadowColor: '#203665'
                        }
                    },
                    hoverAnimation: false,
                    center: ['50%', '50%'],
                    data: [{
                        value: this.detail.maintenanceFinishedRate ? this.detail.maintenanceFinishedRate * 100 : 0,
                        label: {
                            normal: {
                                rich: {
                                    a: {
                                        color: '#ffffff',
                                        align: 'center',
                                        fontSize: 16,
                                        fontWeight: "bold"
                                    },
                                    b: {
                                        color: '#66dbfc',
                                        align: 'center',
                                        fontSize: 14
                                    }
                                },
                                formatter: function(params) {
                                    return "{a|" + params.value + "%" + "}\n\n"+"{b|完成率}";
                                },
                                position: 'center',
                                show: true,
                                textStyle: {
                                    fontSize: '12',
                                    fontWeight: 'normal',
                                    color: '#fff'
                                }
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#5bff63',
                                shadowColor: '#64d13f',
                                shadowBlur: 0
                            }
                        }
                    }, {
                        value: 75,
                        name: 'invisible',
                        itemStyle: {
                            normal: {
                                color: '#142331'
                            },

                        }
                    }]
                },
            ],
        };

      option && this.rainChart.setOption(option);
    },
    initChart() {
      var chartDom = document.getElementById("task3");
      this.chart = echarts.init(chartDom);
      var option;

        option = {
            color: ["#FFA700", "#f0f0f0"],
            tooltip: {
                trigger: "item",
            },
            series: [
                {
                    name: '巡检任务',
                    type: 'pie',
                    clockWise: false,
                    radius: [40, 50],
                    itemStyle: {
                        normal: {
                            label: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            },
                            shadowBlur: 0,
                            shadowColor: '#203665'
                        }
                    },
                    hoverAnimation: false,
                    center: ['50%', '50%'],
                    data: [{
                        value: this.detail.repairFinishedRate ? this.detail.repairFinishedRate * 100 : 0,
                        label: {
                            normal: {
                                rich: {
                                    a: {
                                        color: '#ffffff',
                                        align: 'center',
                                        fontSize: 16,
                                        fontWeight: "bold"
                                    },
                                    b: {
                                        color: '#66dbfc',
                                        align: 'center',
                                        fontSize: 14
                                    }
                                },
                                formatter: function(params) {
                                    return "{a|" + params.value + "%" + "}\n\n"+"{b|完成率}";
                                },
                                position: 'center',
                                show: true,
                                textStyle: {
                                    fontSize: '12',
                                    fontWeight: 'normal',
                                    color: '#fff'
                                }
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#5bbbff',
                                shadowColor: '#3faad1',
                                shadowBlur: 0
                            }
                        }
                    }, {
                        value: 75,
                        name: 'invisible',
                        itemStyle: {
                            normal: {
                                color: '#142331'
                            },

                        }
                    }]
                },
            ],
        };

      option && this.chart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  gap: 1vw;

  .item {
    flex: 1;
    margin-bottom: 0.2vh;
    display: flex;
    align-items: baseline;

    .value {
      font-size: 2vh;
      font-weight: bold;
      color: #299bc5;
    }
    .label {
      font-size: 1.6vh;
      font-weight: 400;
      margin-right: 0.5em;
      color: rgba(255, 255, 255, 0.75);
    }
  }
}
</style>